import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {Notification} from "../../models/notification";
import Helpers from "../../utils/helpers";

@Injectable()
export class NotificationControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getNotificationsList(serviceId: string): Observable<Notification[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/notifications") as Observable<Notification[]> ;
  }

  public getNotification(notificationId: string): Observable<Notification> {
    return this.http.get(this.baseUrl + "notification/" + notificationId) as Observable<Notification> ;
  }

  public createNotification(serviceId: string, notification: Notification): Observable<Notification> {
    Helpers.trimRecursiveObj(notification);
    const body = JSON.stringify(notification);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/notification", body) as Observable<Notification>;
  }

  public saveNotification<T>(notification: Notification) {
    Helpers.trimRecursiveObj(notification);
    const body = JSON.stringify(notification);
    return this.http.put(this.baseUrl + "notification", body, {responseType: "text"});
  }

  public deleteNotification<T>(notificationId: string) {
    return this.http.delete(this.baseUrl + "notification/" + notificationId, {responseType: "text"});
  }

  public sortNotifications<T>(serviceId: string, ids: string[]) {
    const body = JSON.stringify(ids);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/notification/sort", body, {responseType: "text"});
  }

}
